import React from "react"
import { AppAuthCheck } from "../../../Components/Common/AuthCheck/AppAuthCheck"
import { AITrainingList } from "../../../Components/Views/Dashboard/Sections/AppDetail/AIModels/Training/AITrainingList"
import { AppDetailRouteComponentProps } from "../../RouteProps"

export function AppTrainingListRoute({ match }: AppDetailRouteComponentProps) {
    return (
        <AppAuthCheck {...match.params} scope="ai-training:view">
            <AITrainingList {...match.params} />
        </AppAuthCheck>
    )
}
